/* global google */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { GoogleMap } from '@react-google-maps/api';
import get from 'lodash/get';
import take from 'lodash/take';

import { getBoundsZoomLevel } from '../../../../lib/utils';
import VehicleHistoryMarkers from './vehicle-history-markers';

const MAP_EVENT_LIMIT = 200;

function BasicMap({
  onMapMounted, zoom, center, children,
}) {
  return (
    <GoogleMap
      ref={onMapMounted}
      mapContainerStyle={{ width: '100%', height: '100%' }}
      option={{ gestureHandling: 'greedy' }}
      zoom={zoom}
      center={center}
    >
      {children}
    </GoogleMap>
  );
}

const DEFAULT_ZOOM_LEVEL = 15;
const CLICK_ZOOM_LEVEL = 15;
const DEFAULT_CENTER = { lat: 36, lng: -100 };

class HistoryMap extends Component {
  constructor(props) {
    super(props);

    this.state = {
      zoom: DEFAULT_ZOOM_LEVEL,
      center: DEFAULT_CENTER,
    };

    this.setMapBounds = this.setMapBounds.bind(this);
    this.onMarkerClick = this.onMarkerClick.bind(this);
  }

  componentDidMount() {
    const { vehicleEvents } = this.props;
    this.setMapBounds(vehicleEvents);
  }

  onMarkerClick(marker) {
    const { selectedMarker } = this.state;
    if (selectedMarker) {
      selectedMarker.setState({
        showInfo: false,
      });
    }
    marker.setState({
      showInfo: true,
    });
    this.setState({
      selectedMarker: marker,
    });
  }

  setMapBounds(vehicleEvents) {
    const mapBounds = new google.maps.LatLngBounds();

    vehicleEvents.forEach((vehicleEvent) => {
      const { latitude, longitude } = get(vehicleEvent, 'geo', {});

      if (!latitude || !longitude) {
        return undefined;
      }
      mapBounds.extend({ lat: latitude, lng: longitude });
    });

    const zoom = getBoundsZoomLevel(mapBounds, {
      width: document.documentElement.clientWidth,
      height: document.documentElement.clientHeight,
    });

    this.setState({
      center: mapBounds.getCenter(),
      zoom,
    });
  }

  centerOn(latLng) {
    this.setState({
      center: latLng,
      zoom: CLICK_ZOOM_LEVEL,
    });
  }

  render() {
    const {
      vehicleEvents,
      tz,
    } = this.props;
    const { zoom, center } = this.state;
    return (
      <div id="map" style={{ height: '500px', width: '100%' }}>
        <BasicMap
          containerElement={<div style={{ height: '100%' }} />}
          mapElement={<div style={{ height: '100%' }} />}
          onMapMounted={this.handleMapMounted}
          zoom={zoom}
          center={center}
        >
          <VehicleHistoryMarkers
            vehicleEvents={take(vehicleEvents, MAP_EVENT_LIMIT)}
            tz={tz}
            onClick={this.onMarkerClick}
          />
        </BasicMap>
      </div>
    );
  }
}
HistoryMap.propTypes = {
  vehicleEvents: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default HistoryMap;
